import { render, staticRenderFns } from "./ProductSearchAreaMaster.vue?vue&type=template&id=6cbb586a&scoped=true&"
import script from "./ProductSearchAreaMaster.vue?vue&type=script&lang=js&"
export * from "./ProductSearchAreaMaster.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchAreaMaster.vue?vue&type=style&index=0&id=6cbb586a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb586a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
